import React, { Component } from "react";
import { Container } from "./style";

export default class ModalAction extends Component {
  render() {
    return <Container {...this.props}>{this.props.children}</Container>;
  }
}
